var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatePartner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.436,
    height: 27.295,
    viewBox: "0 0 38.436 27.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(-561.735 -568.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_partners",
    transform: "translate(-103.465 190.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_455_",
    transform: "translate(676.14 377.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    d: "M796.957,507.351h10.529a8.8,8.8,0,1,0-.159-10.688,9.868,9.868,0,0,0-1.987-.21,9.653,9.653,0,0,0-9.641,9.641A1.256,1.256,0,0,0,796.957,507.351Zm17.437-11.736a6.287,6.287,0,1,1-6.287,6.287A6.29,6.29,0,0,1,814.394,495.615Z",
    transform: "translate(-795.7 -483.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    d: "M853.165,377.6a5.26,5.26,0,1,0,5.264,5.265A5.268,5.268,0,0,0,853.165,377.6Z",
    transform: "translate(-843.524 -377.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_462_",
    d: "M974.957,558.13h1.257v1.257a1.257,1.257,0,1,0,2.515,0V558.13h1.257a1.257,1.257,0,1,0,0-2.515H978.73v-1.258a1.257,1.257,0,0,0-2.515,0v1.258h-1.257a1.257,1.257,0,1,0,0,2.515Z",
    transform: "translate(-958.778 -538.388)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M676.827,533.11a9.867,9.867,0,0,0-1.987-.21,9.653,9.653,0,0,0-9.641,9.64,1.256,1.256,0,0,0,1.257,1.258h10.529m.62-5.441",
    transform: "translate(0 -142.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M722.665,377.5a5.26,5.26,0,1,0,5.265,5.265A5.274,5.274,0,0,0,722.665,377.5Z",
    transform: "translate(-47.824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePartner);
export default __webpack_public_path__ + "static/media/create_partner.3cd4740942879400180ec1a74f254565.svg";
export { ForwardRef as ReactComponent };